import type { GetInvoicesStatisticsResponse } from '@weft/api-definition';
import { GetInvoicesStatisticsResponseSchema } from '@weft/api-definition';
import { purge } from '@weft/utils';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useInvoiceStatistics(customerId?: string, options?: UseQueryOptions<GetInvoicesStatisticsResponse>) {
  return useQuery({
    queryKey: purge(['invoices-statistics', customerId]),
    queryFn: async () => {
      const api = getPrivateApi();
      const getInvoicesStatisticsResponse = await api.getInvoicesStatistics({ customerId });
  
      return GetInvoicesStatisticsResponseSchema.parse(getInvoicesStatisticsResponse);
    },
    ...options,
  });
}